import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-bgAlt" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[3rem] p-8 md:p-16 shadow-lg border border-brand-gold/30 relative overflow-hidden text-center" data-id="element-155">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-gold via-brand-rose to-brand-gold" data-id="element-156"></div>

          <div className="mx-auto w-24 h-24 bg-brand-bgAlt rounded-full flex items-center justify-center mb-8 border-4 border-brand-gold/20" data-id="element-157">
            <ShieldCheck className="w-12 h-12 text-brand-gold" data-id="element-158" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-brand-plum mb-4" data-id="element-159">
            Tu Inversión Está Completamente Protegida
          </h2>

          <div className="inline-block bg-brand-rose/10 px-6 py-2 rounded-full mb-8" data-id="element-160">
            <p className="text-brand-rose font-bold tracking-wide" data-id="element-161">
              GARANTÍA TOTAL DE 7 DÍAS — SIN PREGUNTAS, SIN CONDICIONES
            </p>
          </div>

          <div className="space-y-6 text-lg text-brand-textLight max-w-2xl mx-auto leading-relaxed" data-id="element-162">
            <p data-id="element-163">
              Quiero que tomes esta decisión desde un lugar de total confianza —
              no de miedo ni de duda.
            </p>
            <p data-id="element-164">
              Por eso, si en los próximos 7 días sientes que este material no
              fue lo que esperabas — por cualquier razón — simplemente
              escríbenos y recibirás el 100% de tu dinero de vuelta.
            </p>
            <p className="font-medium text-brand-plum" data-id="element-165">
              Sin preguntas. Sin procesos complicados. Sin esperas.
            </p>

            <div className="pt-6 border-t border-brand-gold/20 flex flex-col items-center gap-2" data-id="element-166">
              <p className="flex items-center gap-2 text-xl font-bold text-brand-plum" data-id="element-167">
                <span className="text-green-500" data-id="element-168">✅</span> No tienes
                absolutamente nada que perder.
              </p>
              <p className="text-xl font-bold text-brand-rose" data-id="element-169">
                Y tienes una vida completamente nueva por ganar.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}